import {
  Chat,
  MaybeOptimisticChatTextMessage,
} from "@lazarentertainment/public-chat-web"
import { useChannelContext } from "client/components/channel"
import styled from "styled-components"

import { ChatView } from "../../constants"

import { ModerationToolsMenuButton } from "./ChatModerationMenuButton"
import { ReactionMenuButton } from "./ChatReactionMenuButton"

const Container = styled.div`
  display: flex;
`

export const ChatMessageMenu = ({
  showModerationTools,
  message,
  submitMessageReaction,
  banUser,
  deleteChatMessage,
  uiView,
}: {
  message: MaybeOptimisticChatTextMessage
  showModerationTools: boolean
  submitMessageReaction: Chat["toggleReaction"]
  banUser: Chat["banUser"]
  deleteChatMessage: Chat["deleteMessage"]
  uiView: ChatView
}) => {
  const { recordingId } = useChannelContext()
  return (
    <Container>
      {
        // Note: reactions are currently only supported for not-optimistic messages.
        // But this could change in future.
        !recordingId && typeof message.timetoken === "bigint" && (
          <ReactionMenuButton
            message={message}
            submitMessageReaction={submitMessageReaction}
            uiView={uiView}
          />
        )
      }

      <ModerationToolsMenuButton
        showModerationTools={showModerationTools}
        message={message}
        banUser={banUser}
        deleteChatMessage={deleteChatMessage}
        uiView={uiView}
      />
    </Container>
  )
}
